export function getCoinIdsFromPairId(pairId: string): [string, string] {
  const [from, to] = pairId.split('-');
  return [from, to];
}
